import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "./index.css";
import "./styles/minorityReport.css";
import "./styles/scroll-fix.css";
import "./styles/paper.css"; // light mode = parchment & ink (dark mode untouched)
import AppRouter from "./routes";
import theme from "./components/themes/VisionTheme";
import { VerimeterModeProvider } from "./contexts/VerimeterModeContext";
import { AuthBootstrap } from "./services/AuthProvider";

// Register service worker for push notifications
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch((err) =>
    console.warn("[sw] registration failed:", err)
  );
}

// Dev only: route backend calls through the Vite proxy when asked (preview browsers).
const ready: Promise<unknown> =
  import.meta.env.DEV && localStorage.getItem("dev-same-origin-api") === "1"
    ? import("./devSameOriginApi").then((m) => m.enableSameOriginApi())
    : Promise.resolve();

ready.then(() => ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ColorModeScript initialColorMode="dark" />
    <ChakraProvider theme={theme}>
      <VerimeterModeProvider>
        <AuthBootstrap>
          <AppRouter />
        </AuthBootstrap>
      </VerimeterModeProvider>
    </ChakraProvider>
  </React.StrictMode>
));
